import React from 'react'
import { isFunction } from 'lodash'
import dynamic from 'next/dynamic'

import { Loader } from '~/components'
import MainHeader from '~/components/main-header'

import { Container } from './elements'

const getChildren = props => {
  const { children, ...restProps } = props

  if (!isFunction(children)) {
    return children
  }

  return children(restProps)
}

const AccountContent = dynamic(() => import('./account-content'), {
  ssr: false,
  loading: () => (
    <Container>
      <Loader />
    </Container>
  ),
})

const AccountLayout = props => {
  return (
    <>
      <MainHeader />
      <AccountContent {...props} getChildren={getChildren} />
    </>
  )
}

export default AccountLayout
